import { MortgageInterestAccrualReport } from './MortgageInterestAccrualReport.js';

export default MortgageInterestAccrualReport;
